
import React, {useState} from 'react';
import {connect} from 'react-redux';
import {GoogleOAuthProvider, GoogleLogin} from '@react-oauth/google';
import { LoftyLoginWithGoogle } from '../api/user.api';
import { addLoftyToken } from '../actions/auth.actions';

function LoftyGoogleLoginComponent({
  children, addLoftyTokenApp, actionFunction,
  className, id
}) {
  const [hasLoadedData, setHasLoadedData] = useState(true);
  const [googleIdClient, setGoogleIdClient] = useState('');

  if (!hasLoadedData) {
    return null;
  }

  async function loginSuccesAction(response) {
    try {
      const tokenGoogle = response.credential;
      const res = await LoftyLoginWithGoogle({tokenId: tokenGoogle});
      addLoftyTokenApp({ loftytoken: res.token, loftyuser: res.user });
      if (actionFunction) {
        actionFunction()
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <GoogleOAuthProvider
      clientId={googleIdClient}
    >
      <div className={className} id={id}>
        <GoogleLogin
          onSuccess={loginSuccesAction}
          useOneTap
        />
      </div>
    </GoogleOAuthProvider>
  );
}

const mapDispatchToProps = (dispatch) => ({
  addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
});

const mapStateToProps = (state) => state.auth;

export default connect(mapStateToProps, mapDispatchToProps)(LoftyGoogleLoginComponent);
  